const translations = {
  'entryReq.seo.title': 'Entry Requirements for a Trinity TESOL TEFL Course in Spain',
  'entryReq.seo.description': `Find out more about the entry requirements for TEFL Iberia's 160-hour, 1-month, Trinity CertTESOL TEFL course.`,
  'entryReq.sec1.title': 'Entry Requirements',

  'entryReq.sec2.benefitsTitle': 'To Enrol With TEFL Iberia, Applicants Must:',
  'entryReq.sec2.ben1': 'Be over 18 years of age',
  'entryReq.sec2.ben2':
    'Demonstrate an ability to effectively and efficiently communicate in written and spoken English. Please note: Native English is NOT a requirement.',
  'entryReq.sec2.ben3': 'Display enthusiasm and passion for both teaching and learning.',
  'entryReq.sec2.ben4':
    'Possess an ability to deal with the demands of this course – this can be displayed via a higher education degree or through past work experience.',
  'entryReq.sec2.ben5':
    'Be in good enough physical health to deal with the physical rigours of a daily teaching schedule.',
  'entryReq.sec2.ben6':
    'Have a winning, A+ attitude – there’s a reason we pass 98% of all applicants, and it’s because we only accept friendly people with a passion for excellence!',
  'entryReq.sec2.text':
    'To be accepted onto the course you need to complete a short interview (20-25 minutes) with one of our course coordinators to discuss your options, what you want to get out of the course and your plans afterwards.',
};

export default translations;
